import React, { useEffect, useRef, useState } from 'react'
import { Title, TitleGroup, TitleWrapper } from '../../../components/listing/AMSListing';
import StyledText from '../../../components/StyledComponents/StyledText';
import { Button } from '../../../components/form/Button';
import { ButtonWrapper } from '../../../components/ComponentHeader/ComponentHeader';
import ChevronDownIcon from '../../../assets/icons/ChevronDownIcon';
import { FormatOptions, Options } from '../../searchQuery/QueryResultsListing';
import CrossIcon from '../../../assets/icons/CrossIcon';
import { useTheme } from '../../../middleware/ThemeContext';
import ClockIcon from '../../../assets/icons/ClockIcon';
import styled from 'styled-components';

const DashboardHeader = () => {
    const {theme} = useTheme();
    const [filterOptions, setFilterOptions] = useState(false);
    const [filterValue, setFilterValue] = useState("This Month");
    const filterRef = useRef(null);

    function useOutsideAlerter(ref: any) {
        useEffect(() => {
          function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
              setFilterOptions(false);
            }
          }
    
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref]);
      }
    
      useOutsideAlerter(filterOptions && filterRef);

  return (
    <Container theme={theme} className='rounded-0'>
        <div className="d-flex justify-content-between mt-0">
            <div className="d-flex align-items-center gap-2">
                <TitleGroup>
                    <TitleWrapper>
                    <Title theme={theme}>Dashboard Overview</Title>
                    </TitleWrapper>
                    <StyledText className='mt-2' fontSize="14px" fontWeight={300} textColor={theme.CorporateTheme.colors.textSecondary}>
                        Monitor your membership health and financial performance.
                    </StyledText>
                </TitleGroup>
            </div>
            <div className='d-flex gap-3'>
                <ButtonWrapper
                    theme={theme}
                    // disabled={filterDisabled}
                    className="cursor-pointer position-relative"
                    onClick={() => { setFilterOptions(true) }}
                    ref={filterRef}
                >
                    <ClockIcon size={18} />
                    {filterValue ? filterValue : "Scope"}{" "}
                    {/* {filterValue && (
                        <CrossIcon
                        onClick={() => {
                            setFilterValue("");
                        }}
                        size={18}
                        />
                    )}{" "} */}
                    <ChevronDownIcon color={theme.colors.contentText} />
                    {filterOptions && (
                        <FormatOptions theme={theme}>
                        {[
                            { label: "This Month", value: "this-month" },
                            { label: "Last Month", value: "last-month" },
                            { label: "This Year", value: "this-year" },
                        ]?.map((formats, ind) => (
                            <>
                            <Options
                                theme={theme}
                                className="py-2"
                                onClick={() => {
                                    setFilterValue(formats?.label);
                                }}
                            >
                                {formats?.label}
                            </Options>
                            {ind < 3 - 1 && <hr className="my-0" />}
                            </>
                        ))}
                        </FormatOptions>
                    )}
                    </ButtonWrapper>
                <Button
                    theme={theme}
                    $variant='add'
                >Generate Report</Button>
            </div>
        </div>
    </Container>
  )
}

const Container = styled('div')(({ theme }) => ({
  background: theme.CorporateTheme.colors.background,
  borderRadius: theme.CorporateTheme.borderRadius,
  padding: theme.CorporateTheme.spacing.md,
  paddingBottom:0,
  position: 'relative',
}));

export default DashboardHeader